import { Pipe, PipeTransform } from '@angular/core';
import { ReportGroup } from '../../_models/reports';

@Pipe({ name: 'reportGroupFilter' })

export class ReportGroupFilterPipe implements PipeTransform {
  transform(reportGroups: ReportGroup[], groupID: number): ReportGroup {
    let group: ReportGroup = new ReportGroup;
    if (!reportGroups || reportGroups.length == 0) {
      return group;
    }
    for (var i = 0; i < reportGroups.length; i++) {
      if (reportGroups[i].reportGroupID == groupID) {
        group = reportGroups[i];
        break;
      }
    }
    return group;
  }
}
